var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.822388 17.1056L8.16358 11.2366",
    stroke: "#F4BB36",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1776 17.1056L13.8364 11.2366",
    stroke: "#F4BB36",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2608 5.02148L12.3547 12.5126C11.5636 13.178 10.2736 13.1728 9.4879 12.5011L0.739258 5.02148",
    stroke: "#F4BB36",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1639 3.85278H2.83606C1.67803 3.85278 0.739258 4.79155 0.739258 5.94958V16.0504C0.739258 17.2084 1.67803 18.1472 2.83606 18.1472H19.1639C20.322 18.1472 21.2607 17.2084 21.2607 16.0504V5.94958C21.2607 4.79155 20.322 3.85278 19.1639 3.85278Z",
    stroke: "#F4BB36",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.74b01be71de856d4542914a4bba7639d.svg";
export { ForwardRef as ReactComponent };